import { Col, Flex, Row, Spin } from "antd"
import { useSelector } from "react-redux"

import StatisticsCard from "./index"

const StatisticsBlock = () => {
  const fetching = useSelector((state) => state.health.fetching)
  const mainInfo = useSelector((state) => state.health.mainInfo)
  const isMobile = useSelector((state) => state.nav.isMobile)
  const { is_business_health_available } = mainInfo || {}
  const comparisonLabel = mainInfo?.comparison_period?.label

  const dataBlocks = is_business_health_available
    ? mainInfo?.["data_blocks"]
    : mainInfo?.["data_blocks"]?.map((block) => ({ ...block, value: 0 }))

  if (isMobile) {
    return (
      <Spin spinning={fetching}>
        <Row gutter={[12, 12]}>
          {dataBlocks?.map((el, index) => {
            const isLast = index === dataBlocks.length - 1
            const isOddLength = dataBlocks.length % 2 === 1
            return (
              <Col key={el?.title} span={isLast && isOddLength ? 24 : 12}>
                <StatisticsCard stat={el} comparisonLabel={comparisonLabel} />
              </Col>
            )
          })}
        </Row>
      </Spin>
    )
  }

  return (
    <Spin spinning={fetching} wrapperClassName="statistics-spin">
      <Flex gap={12}>
        {dataBlocks?.map((el) => (
          <StatisticsCard key={el?.title} stat={el} comparisonLabel={comparisonLabel} />
        ))}
      </Flex>
    </Spin>
  )
}

export default StatisticsBlock
